'use strict';

angular.module('sharecrf.news', [
    'ngCookies',
    'sharecrf-url',
]);
